<div class="modal-header">
    <h5 class="modal-title">Upload {{uploadInfo.isMaster ? 'Master' : 'Formulary'}}</h5>
    <button type="button" class="btn-close" (click)="dismiss()" aria-label="Close"></button>
</div>
<dirty-tracking [forms]="[masterFileForm]"></dirty-tracking>
<form class="" novalidate #masterFileForm="ngForm" [ngClass]="{'was-validated': submitAttempt}">
    <div class="modal-body">
        <div class="hidden-file-input w-100">
            <input type="file" ng2FileSelect [uploader]="uploader" />
            <button type="button" class="btn btn-round text-strong btn-outline-secondary btn-lg w-100"><i
                    class="far fa-file-search"></i> Choose File</button>
            <input type="text" class="form-control hide" id="OriginalFile" name="OriginalFile" required
                [(ngModel)]="uploadResult.fileId">
            <div class="invalid-feedback">
                <i class="fas fa-exclamation-circle"></i> This field is required.
            </div>
        </div>
        <ng-container *ngIf="uploadResult.fileId">
            <hr />
            <label class="text-muted small">Selected File:</label>
            <p class="text-strong mb-1"><a href="{{uploadResult.fileUrl}}">{{uploadResult.originalName}}</a></p>
            <ul class="list-unstyled d-flex align-items-center">
                <li class="me-3"><span class="text-strong">Row Count:</span> {{uploadResult.rowCount}}</li>
                <li><span class="text-strong">Error Count:</span> {{uploadResult.errorCount}}</li>
            </ul>
            <hr *ngIf="uploadInfo.isMaster" />
            <label class="mb-1" *ngIf="uploadInfo.isMaster">Name</label>
            <input type="text" class="form-control" id="FileName" name="FileName" placeholder="File Name" required
                [(ngModel)]="uploadResult.commonName" *ngIf="uploadInfo.isMaster">
            <div class="invalid-feedback" *ngIf="uploadInfo.isMaster">
                <i class="fas fa-exclamation-circle"></i> This field is required.
            </div>
        </ng-container>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-black btn-round btn-lg" (click)="dismiss()"><i
                class="far fa-times"></i> Cancel</button>
        <button type="submit" class="btn btn-secondary btn-round btn-lg" (click)="save()"><i class="far fa-check"></i>
            Upload
            {{uploadInfo.isMaster ? 'Master' : 'Formulary'}}</button>
    </div>
</form>